(() => {
  const boot = scope => {
    const roots = scope.matches?.('.rvn') ? [scope] : scope.querySelectorAll('.rvn');
    roots.forEach(root => {
      const offer = root.querySelector('[data-rn-offer]');
      const primaryLink = offer?.querySelector('[data-rn-offer-link]');
      const expire = () => {
        root.classList.add('rn-campaign-ended');
        root.querySelectorAll('[data-rn-timer],[data-rn-campaign],[data-rn-sticky]').forEach(el=>el.hidden=true);
        root.querySelectorAll('a[href="#offre"],[data-rn-offer-link],[data-rn-promo-link]').forEach(link=>link.textContent=primaryLink?.dataset.rnExpiredLabel || link.textContent);
        const heading=root.querySelector('[data-rn-promo-title]');
        if(heading)heading.textContent=heading.dataset.rnExpiredTitle;
      };
      root.querySelectorAll('[data-rn-timer]').forEach(timer=>{
        if(timer.dataset.rnReady)return;
        timer.dataset.rnReady='true';
        const end=Date.parse(timer.dataset.deadline);
        const tick=()=>{
          if(!Number.isFinite(end))return false;
          const remaining=Math.max(0,Math.floor((end-Date.now())/1000));
          if(!remaining){expire();return false;}
          const values={days:Math.floor(remaining/86400),hours:Math.floor(remaining%86400/3600),minutes:Math.floor(remaining%3600/60),seconds:remaining%60};
          Object.entries(values).forEach(([key,value])=>{const el=timer.querySelector(`[data-rn-unit="${key}"]`);if(el)el.textContent=String(value).padStart(2,'0');});
          timer.hidden=false;return true;
        };
        if(tick()){const id=setInterval(()=>{if(!timer.isConnected||!tick())clearInterval(id);},1000);}
      });
      root.querySelectorAll('[data-rn-gallery]').forEach(gallery=>{
        if(gallery.dataset.rnReady)return;
        gallery.dataset.rnReady='true';
        const main=gallery.querySelector('.rn-gallery-main');
        gallery.querySelectorAll('[data-rn-thumb]').forEach(button=>button.addEventListener('click',()=>{
          main.src=button.dataset.src;main.removeAttribute('srcset');main.alt=button.dataset.alt;
          gallery.querySelectorAll('[data-rn-thumb]').forEach(other=>other.setAttribute('aria-pressed',String(other===button)));
        }));
      });
      const sticky=root.querySelector('[data-rn-sticky]'),hero=root.querySelector('.rn-hero,.rn-opening');
      if(offer&&!offer.dataset.rnReady&&hero&&'IntersectionObserver' in window){
        offer.dataset.rnReady='true';let pastHero=false,offerVisible=false;
        const sync=()=>{if(sticky)sticky.hidden=!pastHero||offerVisible||root.classList.contains('rn-campaign-ended');};
        new IntersectionObserver(entries=>{pastHero=!entries[0].isIntersecting&&entries[0].boundingClientRect.bottom<0;sync();}).observe(hero);
        new IntersectionObserver(entries=>{offerVisible=entries[0].isIntersecting;sync();}).observe(offer);
      }
      root.querySelectorAll('.rn-comment').forEach(comment=>{
        if(comment.dataset.rnReady)return;
        comment.dataset.rnReady='true';
        comment.querySelectorAll('[data-rn-react]').forEach(button=>button.addEventListener('click',()=>{
          const selected=button.getAttribute('aria-pressed')!=='true',kind=button.dataset.rnReact;
          comment.querySelectorAll('[data-rn-react]').forEach(other=>other.setAttribute('aria-pressed',String(selected&&other.dataset.rnReact===kind)));
        }));
        const toggle=comment.querySelector('[data-rn-hide]'),bubble=comment.querySelector('.rn-comment-bubble');
        if(toggle&&bubble)toggle.addEventListener('click',()=>{bubble.hidden=!bubble.hidden;toggle.setAttribute('aria-expanded',String(!bubble.hidden));toggle.textContent=bubble.hidden?toggle.dataset.showLabel:toggle.dataset.hideLabel;});
      });
      const params=new URLSearchParams(location.search);
      root.querySelectorAll('a[href*="/products/"],a[href*="/pages/raiverie-commande"]').forEach(link=>{
        const url=new URL((window.Shopify?.routes?.root||'/')+'pages/raiverie-commande',location.origin);
        for(const key of ['utm_source','utm_medium','utm_campaign','utm_content','utm_term','fbclid'])if(params.has(key))url.searchParams.set(key,params.get(key));
        link.href=url.href;
      });
    });
  };
  if(window.raiverieNativeV2){window.raiverieNativeV2(document);return;}
  window.raiverieNativeV2=boot;boot(document);
  document.addEventListener('shopify:section:load',event=>boot(event.target.closest('.rvn')||event.target));
})();
